// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function Introduction() {
  return (
    <MKBox component="section" py={8}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={50} md={32}>
            <Grid container justifyContent="flex-start">
              <MKTypography variant="body1" mt={1} mb={0}>
                Whether you’re taking your first breaths underwater or advancing your diving skills,
                our courses are designed for every level. Learn from experienced instructors, gain
                confidence, and explore the ocean safely while having fun.
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Introduction;
